import { Grid, Typography } from "@mui/material";
import React, { FC, ReactElement } from "react";

import loading_video from "../../assets/Server.mp4";

const LoadingDb: FC<any> = (): ReactElement => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      direction="column"
    >
      <video
        className="videos"
        autoPlay={true}
        muted={true}
        loop={true}
        src={loading_video}
      ></video>
      <Typography
        color="secondary"
        fontWeight="bold"
        sx={{
          fontSize: "18px",
        }}
      >
        Loading...
      </Typography>
    </Grid>
  );
};

export default LoadingDb;
